import { colors } from "@/styles/styleVariables";

import { css } from "@emotion/react";

export const button = css`
  all: unset;
  background-color: ${colors.slate["50"]};
  color: ${colors.slate["900"]};
  font-weight: 600;
  padding: 3px 10px; 
  margin-right: 1rem;
  font-size: 1.5rem;
  border-radius: 6px;
  cursor: pointer;
`;

export const active = css`
  background-color: ${colors.slate["900"]};
  color: ${colors.slate["50"]};
`;
